// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { Observable } from 'rxjs';

@Injectable()
export class VAutoService {
  private apiUrl = '/push/vauto';

  public pushTradeLog(params: Object): Observable<any> {
    return this.http.post(this.apiUrl, params);
  }

  constructor(private http: ApplicationHttpClient) {}
}
